import React from 'react';
import './ReservationDetails.scss';
import { ReceiptDetailsAdjustment, StayPanelReservationDetails, UnitPanelReservationDetails } from '..';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import { OccupancyCounts } from '../../types/occupancy';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { ReceiptDetails } from '../Receipt/ReceiptDetails';
import { DiscountDetail } from '../../types/receipt.type';

interface ReservationDetailsProps {
    preview: TripAdjustmentResponse | null;
    discount_details?: DiscountDetail;
    occupancy_details?: { initialOccupancy: OccupancyCounts | null; occupancyCounts: OccupancyCounts | null };
}

export const ReservationDetails: React.FC<ReservationDetailsProps> = (props) => {
    const trip = useSelector((store: { trip: TripState }) => store.trip);
    const { home_info, reservation, guests, stay, unit } = trip;
    const { preview, discount_details, occupancy_details } = props;
    const intl = useIntl();

    if (!home_info || !reservation || !guests || !unit || !stay) {
        return null;
    }
    return (
        <div id={'main-reservation-details'}>
            <br />
            <UnitPanelReservationDetails unit={unit} />
            <StayPanelReservationDetails
                preview={preview}
                occupancy_details={occupancy_details}
                home_info={home_info}
                guests={guests}
                stay={stay}
            />
            {preview ? (
                <ReceiptDetailsAdjustment
                    occupancy_details={occupancy_details}
                    discount_details={discount_details}
                    preview={preview}
                    locale={intl.locale}
                />
            ) : (
                <ReceiptDetails locale={intl.locale} />
            )}
        </div>
    );
};
